
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/s3",
      function () {
        return require("private-next-pages/sources/s3.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/s3"])
      });
    }
  